import moment from 'moment';

const defaultState = {
  searchString: '',
  selectedDate: App.shop && App.shop.currentTime ? moment(App.shop.currentTime) : moment(),
  currentTransactionId: null,
  isChangeDateActive: false,
  refundDisabled: false,
  newTransactionDate: null,
  alert: null
}

const toggleChangeDate = (state) => {
  if (state.currentTransactionId) {
    return {...state, isChangeDateActive: !state.isChangeDateActive, newTransactionDate: state.selectedDate}
  } else {
    return state
  }
}

const alertTitle = (status) => {
  switch (status) {
    case 'voided':
      return 'Transaction Successfully Voided'
    case 'refunded':
      return 'Transaction Successfully Refunded'
    default:
      return 'Refund Error'
  }
}

const alertText = (status) => {
  switch (status) {
    case 'voided':
      return 'The transaction should disappear from the customer’s statement within 24 to 48 hours'
    case 'refunded':
      return 'The customer should see the refund in their account in 2-3 business days'
    default:
      return 'Please contact (305) 800-7534 for Technical Support with this issue'
  }
}

const buildAlert = (status) => {
  return status && {text: alertText(status), title: alertTitle(status), type: status}
}

const transactionsHistory = (state = defaultState, {type, payload}) => {
  switch (type) {
    case 'TRANSACTIONS_HISTORY_DATE_CHANGED':
      return {...state, selectedDate: payload.date}
    case 'TRANSACTIONS_HISTORY_ITEM_CLICKED':
      return {...state, currentTransactionId: payload.id, refundDisabled: payload.refundDisabled}
    case 'TRANSACTIONS_HISTORY_SEARCH_CHANGED':
      return {...state, searchString: payload.searchString}
    case 'TRANSACTIONS_HISTORY.TOGGLE_CHANGE_DATE':
      return toggleChangeDate(state)
    case 'TRANSACTIONS_HISTORY.RETURN_BUTTON':
      return {...state, refundDisabled: payload.refundDisabled}
    case 'TRANSACTIONS_HISTORY.CANCEL_NEW_DATE':
      return {...state, isChangeDateActive: false}
    case 'TRANSACTIONS_HISTORY.CHANGE_NEW_DATE':
      return {...state, newTransactionDate: payload.date}
    case 'TRANSACTION_HISTORY.CHANGE_DATE_SUCCESS':
      return {...state, currentTransactionId: null, isChangeDateActive: false}
    case 'TRANSACTIONS_HISTORY.RELOAD':
      return {...state, currentTransactionId: null, alert: buildAlert(payload.status)}
    case 'TRANSACTIONS_HISTORY.CLEAN_ALERT':
      return {...state, alert: null}
    default:
      return state;
  }
}

export default transactionsHistory
